import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useMutation } from "react-query";
import { useAppContext } from "../../context/appContext";
import idApi from "../../service/IdApi";
import PageHeading from "../../components/PageHeading";
import TokenService from "../../utils/TokenService";
import { throttle } from "lodash";

const MyAccount = () => {
    const { displayAlert } = useAppContext();
    const [firstName, setFirstName] = useState(TokenService.getFirstName());
    const [lastName, setLastName] = useState(TokenService.getLastName());
    const [changesMade, setChangesMade] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
        setChangesMade(true);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
        setChangesMade(true);
    };

    const updateAccount = useMutation(() => {
        var body = {};
        body.firstName = firstName.trim();
        body.lastName = lastName.trim();
        try {
            const data = idApi.patch("auth/user", body).then((response) => response.data);;
            return data;
        } catch (error) {
            throw error;
        }
    });

    // When pressing the enter key on a form
    const onSubmit = (e) => {
        e.preventDefault();
        submitAction();
    };

    const save = (e) => {
        e.preventDefault();
        submitAction();
    };

    const submitAction = throttle(() => {
        setIsProcessing(true);
        var _fn = "";
        if (firstName) {
            _fn = firstName.trim();
        }
        var _ln = "";
        if (lastName) {
            _ln = lastName.trim();
        }
        if (_fn.length === 0) {
            displayAlert("error", "Error", "A first name is required");
            setIsProcessing(false);
            return;
        }
        if (_fn.length === 1) {
            displayAlert("error", "Error", "First name must be at least 2 characters");
            setIsProcessing(false);
            return;
        }
        if (_ln.length === 0) {
            displayAlert("error", "Error", "A last name is required");
            setIsProcessing(false);
            return;
        }
        if (_ln.length === 1) {
            displayAlert("error", "Error", "Please use your full last name");
            setIsProcessing(false);
            return;
        }
        updateAccount.mutate({}, {
            onError: (error, variables, context) => {
                displayAlert("error", "Unexpected Error", "Please try again later");
                setIsProcessing(false);
            },
            onSuccess: (data) => {
                setChangesMade(false);
                displayAlert("success", "Success", "Account information updated");
                setIsProcessing(false);
                TokenService.setAccessToken(data.userAccessToken);
                TokenService.setRefreshToken(data.userRefreshToken);
            },
        }
        );
    }, 500, { trailing: false });

    const reload = (e) => {
        setFirstName(TokenService.getFirstName());
        setLastName(TokenService.getLastName());
        setChangesMade(false);
    };


    const pageHeader = (
        <PageHeading pageTitle="My Account">
            <div className="block">
                <Button label="Save" icon="pi pi-check" className="mr-2" disabled={!changesMade} onClick={save} loading={isProcessing} />
                <Button
                    label="Cancel"
                    icon="pi pi-times"
                    className="p-button-danger"
                    disabled={!changesMade}
                    onClick={reload}
                />
            </div>
        </PageHeading>
    );

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card">
                    <form className="form" onSubmit={onSubmit}>
                        <h5>Public Profile Display Name</h5>
                        <div className="text-left text-lg mb-3">To review companies on Wallist, a name is required to display next to the review. Only the first letter of your last name will be shown. For example, if your name was John Doe, your public profile name would be John D.</div>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="firstname" className="required">First Name</label>
                                <InputText
                                    id="firstname"
                                    type="text"
                                    onChange={handleFirstNameChange}
                                    autoFocus
                                    value={firstName || ""}
                                />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="lastname" className="required">Last Name</label>
                                <InputText
                                    id="lastname"
                                    type="text"
                                    onChange={handleLastNameChange}
                                    value={lastName || ""}
                                />
                            </div>
                        </div>
                        <input type="submit" style={{ display: "none" }} />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MyAccount;
